export const openStatusOptions = [
  { Name: "Alla", Value: -1 },
  { Name: "Öppna", Value: 0 },
  { Name: "Stängda", Value: 2 },
];
